import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxOptional } from '@onyx/angular';
import { DictionaryCode } from '../../../../../../common/enums/dictionary-code';
import { InvoiceType } from '../../../../../../common/enums/invoice-type';
import { ContractorInvoiceCollectiveIssueTermComponent } from '../../components/contractor-invoice-collective-issue-term/contractor-invoice-collective-issue-term.component';
import { CollectiveInvoiceIssueTerm } from '../../enums/collective-invoice-issue-term';
import type { ContractorInvoice } from '../../interfaces/contractor';

@Component({
  selector: 'app-contractor-default-invoice-cell',
  imports: [TranslatePipe, ContractorInvoiceCollectiveIssueTermComponent],
  templateUrl: './contractor-default-invoice-cell.component.html',
  styleUrl: './contractor-default-invoice-cell.component.scss',
})
export class ContractorDefaultInvoiceCellComponent {
  public readonly invoice = input.required<OnyxOptional<ContractorInvoice>>();

  protected readonly DictionaryCode = DictionaryCode;
  protected readonly InvoiceType = InvoiceType;
  protected readonly CollectiveInvoiceIssueTerm = CollectiveInvoiceIssueTerm;
}
